import { memo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { DISPLAY_EXCHANGE_NAME, LAYOUT_TYPE, ORDER_PRODUCT_TYPES, ORDER_TYPES, POSITION_TYPES, SCRIP_INSTRUMENTS, SIP_ORDER_BY_OPTIONS, WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
import { deepClone, getMktSegIdFromApiExchangeName, getOrderDisplayDiscription, getToFixedParseFloat } from '../../utils/global_functions';
import { BzButton } from '../../components';
import { _getQtyLotCaption } from '../../controllers';
import { useDispatch, useSelector } from 'react-redux';
import { handleModal } from '../../redux/actions/modals';

const OrderStatusBody = (props) => {
    const { layoutType = LAYOUT_TYPE.VERTICAL, activeTabKey, objScripData, scripOrderInfo, orderEntryTab, orderId, isCancel, isRemoveScrip, isSquareOf, arrBucketOrderIds,
        // Vinit Raut : 25-01-2024 : BT-107418 - Breeze – SIP Order book -- Start 
        isMultipleCancel, sipStatusType = false,
        // Vinit Raut : 25-01-2024 : BT-107418 - Breeze – SIP Order book -- End 
        selectOrderOption = {}, orderInputs = {},
        moreConversionData = {}//Ameersha N - This variable will have more data related scrip which we slected for conversion
    } = props;
    const objOrderCartOrderResp = useSelector(state => state?.orderCart?.placeOrderCartOrderSuccess); //BT-106965 : Order Cart : ManasaB : 23-07-2024 : Side tray code changes 
    const multiSpreadOrderInfo = useSelector(state => state.orders.multiSpreadOrderInfo);
    const SingleScripMsg = () => {
        //Maaz A : 28-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - MCX Issues Fixes - Start
        const nDecimalLocatorLength = scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH];
        switch (objScripData?.order_type) {
            case 'RL-MKT': {
                if (objScripData?.coverOrBracket == ORDER_PRODUCT_TYPES.BRACKET) {
                    return (
                        <div className='font-medium font-size4 color-text'>You have placed an order to {objScripData?.transaction_type} {objScripData?.quantity} {scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? 'share(s)' : 'lot(s)'} {scripOrderInfo[WATCHLIST_GRID_INDEX.DISPLAY_DESC]} @ Market Price with SL Trigger @ &#8377;{getToFixedParseFloat(objScripData?.intradayTrigger, nDecimalLocatorLength)} and SL Limit @ &#8377;{getToFixedParseFloat(objScripData?.intradayLimit, nDecimalLocatorLength)}, Trailing SL @ {objScripData?.intradayTrailing}, Book Profit @ &#8377;{getToFixedParseFloat(objScripData?.intradayProfit, nDecimalLocatorLength)}</div>
                    );
                } else if (objScripData?.coverOrBracket == ORDER_PRODUCT_TYPES.COVER) {
                    return (
                        <div className='font-medium font-size4 color-text'>You have placed an order to {objScripData?.transaction_type} {objScripData?.quantity} {scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? 'share(s)' : 'lot(s)'} {scripOrderInfo[WATCHLIST_GRID_INDEX.DISPLAY_DESC]} @ Market Price with SL Trigger @ &#8377;{getToFixedParseFloat(objScripData?.intradayTrigger, nDecimalLocatorLength)} and SL Limit @ &#8377;{getToFixedParseFloat(objScripData?.intradayLimit, nDecimalLocatorLength)}</div>
                    );
                } else {
                    // Ameersha N : Breeze : 23-02-2024 : BT-102298 : Issue NSE FNO FIX--Start
                    return (
                        <div className='font-medium font-size4 color-text'>You have placed an order to {objScripData?.transaction_type} {scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? orderInputs?.scripQuantity : orderInputs?.scripLot} {scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? 'share(s)' : `Lot(${orderInputs?.scripQuantity})${scripOrderInfo[WATCHLIST_GRID_INDEX.EXCHANGE]?.toUpperCase() === DISPLAY_EXCHANGE_NAME.MCX_EXCHANGE_TEXT || scripOrderInfo[WATCHLIST_GRID_INDEX.EXCHANGE]?.toUpperCase() === DISPLAY_EXCHANGE_NAME.NCDEX_EXCHANGE_TEXT ? ' ' + scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_QUOTATION_UNIT] : ''}`} {scripOrderInfo[WATCHLIST_GRID_INDEX.DISPLAY_DESC]} @ Market Price</div>
                    );
                    // Ameersha N : Breeze : 23-02-2024 : BT-102298 : Issue NSE FNO FIX--End
                }
            }
            case 'RL': {
                if (objScripData?.coverOrBracket == ORDER_PRODUCT_TYPES.BRACKET) {
                    return (

                        <div className='font-medium font-size4 color-text'>You have placed an order to {objScripData?.transaction_type} {objScripData?.quantity} {scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? 'share(s)' : 'lot(s)'} {scripOrderInfo[WATCHLIST_GRID_INDEX.DISPLAY_DESC]} @ Market Price with SL Trigger @ &#8377;{getToFixedParseFloat(objScripData?.intradayTrigger, nDecimalLocatorLength)} and SL Limit @ &#8377;{getToFixedParseFloat(objScripData?.intradayLimit, nDecimalLocatorLength)}, Trailing SL @ {objScripData?.intradayTrailing}, Book Profit @ &#8377;{getToFixedParseFloat(objScripData?.intradayProfit, nDecimalLocatorLength)}</div>
                    );
                } else if (objScripData?.coverOrBracket == ORDER_PRODUCT_TYPES.COVER) {
                    return (
                        <div className='font-medium font-size4 color-text'>You have placed an order to {objScripData?.transaction_type} {objScripData?.quantity} {scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? 'share(s)' : 'lot(s)'} {scripOrderInfo[WATCHLIST_GRID_INDEX.DISPLAY_DESC]} @ Market Price with SL Trigger @ &#8377;{getToFixedParseFloat(objScripData?.intradayTrigger, nDecimalLocatorLength)} and SL Limit @ &#8377;{getToFixedParseFloat(objScripData?.intradayLimit, nDecimalLocatorLength)}</div>
                    );
                } else {
                    // Ameersha N : Breeze : 23-02-2024 : BT-102298 : Issue NSE FNO FIX--Start
                    return (
                        <div className='font-medium font-size4 color-text'>You have placed an order to {objScripData?.transaction_type}  {scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? orderInputs?.scripQuantity : orderInputs?.scripLot} {scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? 'share(s)' : `Lot(${orderInputs?.scripQuantity}${scripOrderInfo[WATCHLIST_GRID_INDEX.EXCHANGE]?.toUpperCase() === DISPLAY_EXCHANGE_NAME.MCX_EXCHANGE_TEXT || scripOrderInfo[WATCHLIST_GRID_INDEX.EXCHANGE]?.toUpperCase() === DISPLAY_EXCHANGE_NAME.NCDEX_EXCHANGE_TEXT ? ' ' + scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_QUOTATION_UNIT] : ''})`} of {scripOrderInfo[WATCHLIST_GRID_INDEX.DISPLAY_DESC]} @ &#8377;{getToFixedParseFloat(objScripData?.price, nDecimalLocatorLength)}</div>
                    );
                    // Ameersha N : Breeze : 23-02-2024 : BT-102298 : Issue NSE FNO FIX--End
                }
            }
            case 'SL-MKT': {
                // Ameersha N : Breeze : 23-02-2024 : BT-102298 : Issue NSE FNO FIX
                return (
                    <div className='font-medium font-size4 color-text'>You have placed an SL order to {objScripData?.transaction_type} {scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? orderInputs?.scripQuantity : orderInputs?.scripLot} {scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? 'share(s)' : `Lot(${orderInputs?.scripQuantity})${scripOrderInfo[WATCHLIST_GRID_INDEX.EXCHANGE]?.toUpperCase() === DISPLAY_EXCHANGE_NAME.MCX_EXCHANGE_TEXT || scripOrderInfo[WATCHLIST_GRID_INDEX.EXCHANGE]?.toUpperCase() === DISPLAY_EXCHANGE_NAME.NCDEX_EXCHANGE_TEXT ? ' ' + scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_QUOTATION_UNIT] : ''}`} {scripOrderInfo[WATCHLIST_GRID_INDEX.DISPLAY_DESC]} @ Market Price with SL Trigger @ &#8377;{getToFixedParseFloat(objScripData?.trigger_price, nDecimalLocatorLength)}</div>
                );
            }
            case 'SL': {
                // Ameersha N : Breeze : 23-02-2024 : BT-102298 : Issue NSE FNO FIX--Start
                return (
                    <div className='font-medium font-size4 color-text'>You have placed an SL order to {objScripData?.transaction_type} {scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? orderInputs?.scripQuantity : orderInputs?.scripLot} {scripOrderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? 'share(s)' : `Lot(${orderInputs?.scripQuantity})${scripOrderInfo[WATCHLIST_GRID_INDEX.EXCHANGE]?.toUpperCase() === DISPLAY_EXCHANGE_NAME.MCX_EXCHANGE_TEXT || scripOrderInfo[WATCHLIST_GRID_INDEX.EXCHANGE]?.toUpperCase() === DISPLAY_EXCHANGE_NAME.NCDEX_EXCHANGE_TEXT ? ' ' + scripOrderInfo?.[WATCHLIST_GRID_INDEX.PRICE_QUOTATION_UNIT] : ''}`} {scripOrderInfo[WATCHLIST_GRID_INDEX.DISPLAY_DESC]} @ &#8377;{getToFixedParseFloat(objScripData?.price, nDecimalLocatorLength)} with SL Trigger @ &#8377;{getToFixedParseFloat(objScripData?.trigger_price, nDecimalLocatorLength)}</div>
                );
            }
            default:
                return null;
        }
        //Maaz A : 28-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - MCX Issues Fixes - End
    };

    {/* Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676 --Start  */ }
    const SipMsg = () => {
        let frequencyText = "";
        switch (objScripData?.selectOrderOption?.frequency) {
            case 'MONTHLY':
                frequencyText = "every month";
                break;

            case 'WEEKLY':
                frequencyText += "every week";
                break;

            case 'DAILY':
                frequencyText += "daily";
                break;

            case 'FORTHNIGHTLY':
                frequencyText = "fortnightly";
                break;
            default:
                break;
        }

        return (
            isCancel ? <div className='font-medium font-size4 color-text'>Orders Cancelled Successfully</div> :
                <div className='font-medium font-size4 color-text'> You have placed an Equity SIP order to {objScripData?.transaction_type}  {objScripData?.quantity} {objScripData?.selectOrderOption?.orderBy === SIP_ORDER_BY_OPTIONS.QUANTITY ? SIP_ORDER_BY_OPTIONS.QUANTITY : SIP_ORDER_BY_OPTIONS.VALUE} share(s) of {scripOrderInfo[WATCHLIST_GRID_INDEX.SYMBOL]} {frequencyText} for {objScripData?.no_of_installments} installments {parseFloat(objScripData?.cap_price) > 0 ? `at Cap Price @ ${String.fromCharCode(8377)}${parseFloat(objScripData?.cap_price)}` : ''}</div>
        );
    };
    {/* Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676 -- End  */ }

    // Vinit Raut : 22-05-2024 : BT-107418 - Breeze – SIP Order book -- Start 
    const SipOrderStatusMsg = ({ sipStatusType }) => {
        let sipStatusMsg = '';
        switch (sipStatusType) {
            case "Pause":
                sipStatusMsg = "Paused";
                break;

            case "Resume":
                sipStatusMsg = "Resumed";
                break;

            case "Stop":
                sipStatusMsg = "Stopped";
                break;
        }

        return (
            <div className='font-medium font-size4 color-text'>Order {sipStatusMsg}</div>
        );
    };
    // Vinit Raut : 22-05-2024 : BT-107418 - Breeze – SIP Order book -- End 

    // const objSquareOffPositions = useSelector(state => state?.netPosition?.objSquareOffPositions);

    // const [squareoffOrderId, setsquareoffOrderId] = useState('');
    // useEffect(() => {
    //     if (objSquareOffPositions?.status === API_RESPONSE_STATUS.SUCCESS && objSquareOffPositions.data.length > 0) {
    //         setsquareoffOrderId(objSquareOffPositions.data[0].data.orderId);
    //     }
    // }, [objSquareOffPositions]);


    /*Mahesh S  : 19-06-2023 : BT-102838 -  Breeze - Net Position - Start*/

    {/* Vinit R : 02-01-2024 : BT-102298 NSEFAO Netposition – Start */ }
    const PositionMsg = () => {
        //Azeem  K : 16-05-2024 : BT-102298 ALL segments Netposition – Start 
        const dispatch = useDispatch();
        const handleClose = () => {
            dispatch(handleModal([{ 'ORDER_STATUS': false }]));
        };
        //Azeem  K : 16-05-2024 : BT-102298 ALL segments Netposition – End 

        return (
            objScripData?.isSquareOf ? <div className='font-medium font-size4 color-text'>Orders Squared Off Successfully</div> :
                <>
                    <div className='font-medium font-size4 color-text'>
                        Your Position conversion request of {objScripData?.productType} order for {objScripData?.scripName} {moreConversionData?.exchange}  {getOrderDisplayDiscription({
                            expiryDate: moreConversionData?.ScripData[0]?.nExpiryDate1,
                            strikePrice: parseInt(moreConversionData?.strike_price) >= 0 ? moreConversionData?.strike_price : '',
                            optionType: moreConversionData?.option_type,
                            series: moreConversionData?.series,
                            instrument: moreConversionData?.instrument
                        })} ({objScripData?.scripQuantity} {_getQtyLotCaption(getMktSegIdFromApiExchangeName(moreConversionData?.preferred_exchange), moreConversionData?.market_lot, false)}) to {objScripData?.selectedType} Order has been submitted
                    </div>
                    <BzButton className='btn btn-md btn-outline mt-4' onClick={handleClose}>Close</BzButton>
                </>
        );
    };
    {/* Vinit R : 02-01-2024 : BT-102298 NSEFAO Netposition – End */ }
    /*Mahesh S  : 19-06-2023 : BT-102838 -  Breeze - Net Position - End*/

    //Parshva S : 5/4/23 : BT-107070 - Breeze - Spread Order entry - Start
    const SpreadOrderMsg = () => {
        let copyData = layoutType === LAYOUT_TYPE.VERTICAL ? deepClone(multiSpreadOrderInfo) : deepClone(objScripData?.scripOrderInfo);
        let buyScrip = copyData?.spreadOrderPayload?.leg_details?.find(eachLeg => eachLeg?.transaction_type === "BUY");
        let selScrip = copyData?.spreadOrderPayload?.leg_details?.find(eachLeg => eachLeg?.transaction_type === "SELL");
        return (
            <div className='font-medium font-size4 color-text'>You have placed a Spread order to
                {copyData?.spreadOrderPayload?.leg_details.map((x, i) =>
                    <><span className={`${x?.transaction_type === 'BUY' ? 'color-positive' : 'color-negative'}`}> {x?.transaction_type} </span>
                        {`${x?.scrip_info?.symbol} ${x?.scrip_info?.expiry_date}  ${i < copyData?.spreadOrderPayload?.leg_details.length - 1 ? 'and' : ''} `}
                    </>)}
                {/* <span className='color-negative'>SELL </span>
                {`${selScrip?.scrip_info
                    ?.symbol} ${selScrip?.scrip_info?.expiry_date}  and `}
                <span className='color-positive'>BUY </span>
                {`${buyScrip?.scrip_info
                    ?.symbol} ${buyScrip?.scrip_info?.expiry_date}  `} */}
                for {copyData?.quantity} Lot ({buyScrip?.quantity
                } shares)

            </div>
        );
    };
    //Parshva S : 5/4/23 : BT-107070 - Breeze - Spread Order entry - End
    //BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - Start
    const BucketOrderMsg = () => {
        //BT-106965 : Order Cart : ManasaB : 23-07-2024 : Side tray code changes - Start
        let arrOrderIds = [];
        if (layoutType == LAYOUT_TYPE.VERTICAL && arrBucketOrderIds == undefined) {
            arrOrderIds = objOrderCartOrderResp?.data.map(eachData => {
                return { orderId: eachData?.data?.orderId };
            });
        }
        else {
            arrOrderIds = [...arrBucketOrderIds];
        }
        return (
            <>
                <div className='font-medium font-size4 color-text'>Order(s) Placed Successfully</div>
                {arrOrderIds?.length > 0 && arrOrderIds?.map(eachOrder => {
                    return <div><span className='font-regular font-size2 color-subtext'>Order ID: {eachOrder.orderId}</span></div>;
                })}
            </>
        );
        //BT-106965 : Order Cart : ManasaB : 23-07-2024 : Side tray code changes - End
    };
    //BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - End
    // Parshva S - 15/11/2023 BT-102679 - Breeze- Multi Leg order entry - start
    const MultiLegOrderMsg = () => {
        return (
            <div className='font-medium font-size4 color-text'> You have placed a Multi Leg order to
                {objScripData.leg_details?.map((lg, index) =>
                    <>
                        <span className={`${lg.transaction_type === 'BUY' ? 'color-positive' : 'color-negative'}`}>
                            {` ${lg.transaction_type} `}
                        </span>
                        {lg?.scrip_info?.symbol} {lg?.scrip_info?.expiry_date} {lg.scrip_info.strike_price !== "" ? lg.scrip_info.strike_price : null} {lg.scrip_info.option_type !== "" ? lg.scrip_info.option_type : null} {index < objScripData.leg_details.length - 1 ? "," : null}
                    </>
                )}
            </div>
        );
    };
    // Parshva S - 15/11/2023 BT-102679 - Breeze- Multi Leg order entry - end

    const OrderStatusMsg = () => {
        switch (orderEntryTab) {
            // Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
            case ORDER_TYPES.GOOD_TILL_DATE:
                if (isCancel) {
                    return <div className='font-medium font-size4 color-text'>Orders Cancelled Successfully</div>;
                } else {
                    return <div className='font-medium font-size4 color-text'></div>;
                }
            // Maaz A : 20-10-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
            case ORDER_TYPES.SINGLE_SCRIP: {
                if (isCancel) {

                    return <div className='font-medium font-size4 color-text'>Your order cancellation request for {objScripData?.title} {objScripData?.exchange}  {getOrderDisplayDiscription(objScripData)}  has been submitted </div>;
                } else if (isSquareOf) {
                    return <div className='font-medium font-size4 color-text'>Orders Squared Of Successfully</div>;
                    // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
                } else if (isMultipleCancel) {
                    return <div className='font-medium font-size4 color-text'>Cancel order's request submitted</div>;
                    // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
                } else {
                    return <SingleScripMsg />;
                }
            }
            // Vinit Raut : 25-01-2024 : BT-107418 - Breeze – SIP Order book -- Start 
            case ORDER_TYPES.EQUITY_SIP: {
                if (Boolean(sipStatusType)) return <SipOrderStatusMsg sipStatusType={sipStatusType} />;
                else return <SipMsg />;
            }
            // Vinit Raut : 25-01-2024 : BT-107418 - Breeze – SIP Order book -- End
            case POSITION_TYPES.NET_POSITION: {
                return <PositionMsg />;
            }
            case ORDER_TYPES?.MULTI_SCRIP: {
                if (isCancel) {
                    return <div className='font-medium font-size4 color-text'>Your order cancellation request for {objScripData?.title} has been submitted </div>;
                } else if (orderEntryTab === ORDER_TYPES?.MULTI_SCRIP && activeTabKey === ORDER_TYPES?.MULTI_LEG) {
                    return <MultiLegOrderMsg />;
                } else if (orderEntryTab === ORDER_TYPES?.MULTI_SCRIP && activeTabKey === ORDER_TYPES?.SPREAD) {
                    return <SpreadOrderMsg />;
                }
                //BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - Start
                else if (orderEntryTab === ORDER_TYPES?.MULTI_SCRIP && activeTabKey === ORDER_TYPES?.BASKET) {
                    return <BucketOrderMsg />;
                }
                //BT-124975 : ManasaB :11/01/2024 : Order Cart : API Integration for Save Cart and Place Order - End
            }
            default:
                return null;
        }
    };



    return (
        <Container fluid className={`p-0 ${layoutType !== LAYOUT_TYPE.HORIZONTAL ? 'oe-sidetray-success-block' : ''} px-0`}>
            <Row className='g-0 py-3'>
                <div className='text-center'>
                    <Col md='auto'>
                        <div className='icon-64 icon-done icon-positive'></div>
                    </Col>
                </div>
            </Row>
            <Row className='g-0 mb-3'>
                <Col className='text-center px-3'>
                    {
                        isRemoveScrip ?
                            <div className='font-medium font-size4 color-text'>Scrips deleted successfully!</div>
                            :
                            <OrderStatusMsg />
                    }
                </Col>
            </Row>
            {
                orderId &&
                <Row className='g-0 mb-3'>
                    <Col className='d-flex justify-content-center align-items-center'>
                        <div className='font-regular font-size3 color-subtext'>Order ID: {orderId}</div>
                    </Col>
                </Row>
            }
        </Container>
    );
};

export default memo(OrderStatusBody);
